import React from 'react';

import styles from './style';

const Text = (props) => {
  const {
    className,
    text,
    color,
    size,
    bold,
    underline,
    italic,
    marginLeft,
    marginRight,
    children,
    marginTop,
    marginBottom
  } = props;

  const textStyles = { ...styles.text };

  if (color) {
    textStyles.color = color;
  }
  if (size) {
    textStyles.fontSize = size;
  }
  if (bold) {
    textStyles.fontWeight = 'bold';
  }
  if (color) {
    textStyles.text = color;
  }
  if (underline) {
    textStyles.textDecoration = 'underline';
  }
  if (italic) {
    textStyles.fontStyle = 'italic';
  }
  if (marginLeft) {
    textStyles.marginLeft = marginLeft;
  }
  if (marginRight) {
    textStyles.marginRight = marginRight;
  }
  if (marginTop) {
    textStyles.marginTop = marginTop;
  }
  if (marginBottom) {
    textStyles.marginBottom = marginBottom;
  }

  return (
    <span className={className} style={textStyles}>
      {text || children || ''}
    </span>
  );
};

export default Text;
